import { render, staticRenderFns } from "./FlexJustify.vue?vue&type=template&id=2bc88a67&"
import script from "./FlexJustify.vue?vue&type=script&lang=js&"
export * from "./FlexJustify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports